import hangup from "../../assets/icons/hangup.png";
import mutedIcon from "../../assets/icons/muted.png";
import sound from "../../assets/icons/sound.png";
import xcall from "../../assets/icons/xcall.png";
import callIcon from "../../assets/icons/call.png";
import ConfirmPopup from "../../commons/components/ConfirmPopup/ConfirmPopup";
import { REACT_APP_DEEPLINK } from "../../commons/constants";
import "./call.scss";

interface Props {
  hangupCall: any;
  mutedCall: any;
  turnOffAudio: any;
  muted: boolean;
  audio: boolean;
  name: string | null;
  isAnswered: boolean;
  count: number;
  linkRef: any;
  open: boolean;
  call: any;
  isCalling: boolean;
}

const CallConsumer: React.FC<Props> = ({
  hangupCall,
  mutedCall,
  muted,
  turnOffAudio,
  audio,
  name,
  isAnswered,
  count,
  linkRef,
  open,
  call,
  isCalling,
}) => {
  function converCount(count: number) {
    const minutes = Math.floor(count / 60);
    const second = count < 10 ? `0${count}` : `${count}`;
    if (minutes < 1) {
      return `00 : ${second}`;
    } else {
      return `${minutes < 10 ? `0${minutes}` : `${minutes}`}  :  ${count % 60 < 10 ? `0${count % 60}` : count % 60}`;
    }
  }

  return (
    <div className="container">
      <div className="container-call">
        <div className="consumer-avatar">
          <div className="avatar">
            <div className="logo">{name?.at(0) || "U"}</div>
          </div>
          <p className="name">{name || "User"}</p>
          {isAnswered ? (
            <p className="count">{converCount(count)}</p>
          ) : (
            <>
              <p className={isCalling ? "ring" : ""}>Ringing....</p>
            </>
          )}
        </div>

        {isCalling ? (
          <>
            <div className="buttons">
              <img
                src={mutedIcon}
                className=""
                alt="muted"
                onClick={() => mutedCall()}
                style={{
                  opacity: muted ? 1 : 0.5,
                }}
              />

              <a target="_blank" rel="noreferrer" href={REACT_APP_DEEPLINK} onClick={() => hangupCall()} ref={linkRef}>
                <img src={hangup} alt="hangup" />
              </a>

              <img
                src={sound}
                alt="sound"
                style={{
                  opacity: audio ? 1 : 0.5,
                }}
                onClick={() => {
                  turnOffAudio();
                }}
              />
            </div>
          </>
        ) : (
          <>
            <div className="buttons">
              <img src={callIcon} alt="callIcon" onClick={() => call()} />
              <a target="_blank" rel="noreferrer" href={REACT_APP_DEEPLINK} onClick={() => hangupCall()} ref={linkRef}>
                <img src={xcall} alt="callIcon" />
              </a>
            </div>
          </>
        )}
      </div>

      <ConfirmPopup open={open} title="Call End" description="" onConfirm={() => linkRef.current.click()} />
    </div>
  );
};

export default CallConsumer;
